import { Components, PathsObject, RequestType } from "../../../yaml-content";
import ParametersTable from "./parameters_table";
import React from "react";
import ResponseTable from "./response_table";

type Props = {
  method: string;
  path: string | null;
  request: RequestType;
  components: Components;
  item: PathsObject;
};

const RequestTypeComponent = ({
  method,
  path,
  request,
  components,
  item,
}: Props) => {
  function capitalizeFirstLetter(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  function getOpId(path: string): string {
    let opId = "";
    const matches = path.match(/[^/]+(?=\/$|$)/);
    if (matches) {
      const operation = matches[0];
      if (operation) {
        const words = operation.match(/([a-z]+)/g);
        if (words) {
          opId = method.toLowerCase();
          words.map((word) => {
            opId += capitalizeFirstLetter(word);
          });
        }
      }
    }
    return opId;
  }

  const opId = request.operationId || (path && getOpId(path));

  return (
    <div className="sec3 relative">
      <div
        className="anchor absolute inset-0 -z-50 -top-[90px] bottom-[90px] lg:-top-[120px] lg:bottom-[120px]"
        id={`_${opId}`}
      />
      <h4 className="!pt-4 !text-lg"
        data-adoc-section-id={`_${opId}`}
        data-adoc-section-title={request.summary || opId}
      >
        {request.summary || opId}
        <a href={`#_${request.operationId}`}>
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 24 24"
            height="22"
            width="22"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"></path>
          </svg>
        </a>
      </h4>
      <div className="flex flex-col ">
        <div className="flex flex-row justify-start items-center mt-4 mb-2">
          <div className="py-px px-2 text-center text-xs text-white border border-black bg-gray-700 rounded-md mr-2">
            {method.toUpperCase()}
          </div>
          <span className="items-center h-full text-2xl text-black paragraph">
            <p className="align-middle mb-0">{path}</p>
          </span>
        </div>
        <div className="sect4">
          <div>
            <div className="relative">
              <div
                className="anchor absolute inset-0 -z-50 -top-[90px] bottom-[90px] lg:-top-[120px] lg:bottom-[120px]"
                id="_description_7"
              ></div>
              Description
            </div>
          </div>
          <div className="paragraph">
            <p>
              {(request.description &&
                request.description?.replace(/\*Note:.*/g, "")) ||
                item.summary}
            </p>
            <p />
          </div>
          {path && path.includes("beta") && (
            <div className="p-2 m-2 border-l-8 border-blue-500 bg-blue-100 flex flex-col">
              <div className="flex flex-row justify-start items-center mb-2">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 24 24"
                  className="mr-4 text-blue-500"
                  height="20"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path d="M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z"></path>
                </svg>
                <div className="text-lg text-blue-500">Note</div>
              </div>
              <div className="text-base text-black">
                This is a beta endpoint with known limitations.
              </div>
            </div>
          )}
        </div>
        {(item.parameters || request.parameters || request.requestBody) && (
          <div className="sect4">
            <ParametersTable
              parameters={item.parameters || request.parameters}
              bodyParameter={request.requestBody}
              componentSchemas={components.schemas}
            />
          </div>
        )}
        {request.responses && request.responses.length > 0 && (
          <div className="sect4">
            <ResponseTable
              responses={request.responses}
              componentResponses={components.responses}
              componentSchemas={components.schemas}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestTypeComponent;
